import { BrowserHistory, createBrowserHistory, Location, Update } from 'history';

import { captureGoogleClickIds } from './googleAttribution';

type RouterUpdate = Update & {
  delta: number;
};

interface ExtendedHistory extends BrowserHistory {
  createURL: (location: Location | string) => URL;
  encodeLocation: (location: Location) => Location;
  listen: (listener: (update: RouterUpdate) => void) => () => void;
}

// Capture before route redirects can discard landing-page parameters.
captureGoogleClickIds();
const baseHistory = createBrowserHistory();
baseHistory.listen(({ location }) => captureGoogleClickIds(location.search));

const history: ExtendedHistory = {
  ...baseHistory,
  createURL: (location) => {
    const href = baseHistory.createHref(location);
    return new URL(href, window.location.origin);
  },
  encodeLocation: (location) => location,
  listen: (listener) => {
    return baseHistory.listen((update) => {
      const routerUpdate: RouterUpdate = {
        ...update,
        delta: 0,
      };
      listener(routerUpdate);
    });
  },
};

export default history;
